import React from "react";
import "../styles/Works.css";
import { FiGithub } from "react-icons/fi";
import { WorkData } from "../data/WorkData";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Works = () => {
	const fade = {
		opacity: 1,
		transition: {
			duration: 1.4,
		},
	};

	return (
		<>
			<div className='works' id='works'>
				<div className='container'>
					<motion.div
						initial={{ opacity: 0 }}
						whileInView={fade}
						viewport={{ once: true }}
						className='heading'>
						<p className='heading-sub-text'>I build real value</p>
						<p className='heading-text'>Projects</p>
					</motion.div>

					<motion.div
						className='works-box'
						initial={{ opacity: 0 }}
						whileInView={fade}>
						{WorkData.map((w, index) => {
							return (
								<div key={index}>
									<div className='work-link-group'>
										<div className='works-card'>
											<div className='works-container'>
												<div className='top-work'>
													<div className='right'>
														{w.confidential ? <p className='work-disclaimer'>{w.disclaimer} </p>
														 : <Link
															className='work-git'
															to={w.gitlink}
															target='_blank'>
															<FiGithub />
														</Link>}
														{/* <Link
															className='work-git'
															to={w.gitlink}
															target='_blank'>
															<FiGithub />
														</Link> */}
													</div>
												</div>
												<div className='mid-work'>
													<p className='work-title'>{w.title}</p>
													<p className='work-desc'>{w.desc}</p>
												</div>
												<div className='bottom-work'>
													{w.tech.map((e, index) => {
														return <small key={index}>{e}</small>;
													})}
												</div>
											</div>
										</div>
									</div>
								</div>
							);
						})}
					</motion.div>
				</div>
			</div>
		</>
	);
};

export default Works;
